import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const JournalTransactions = () => {
  return <ErpTablePage moduleKey="journal_entries" />;
};

export default JournalTransactions;